module.exports = __webpack_public_path__ + "static/media/banner.a852c10d.png";